declare const ENV_WS_MQTT_URL: string | undefined;

export const WS_MQTT_URL = ENV_WS_MQTT_URL || "ws://localhost:9883";
